const initialState = {
    isLoading: false,
    detail: null,
    event: null,
    submitting: false,
    submitted: null,
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'GROUPS:GET_GROUP_DETAILS':
            return {
                ...state,
                isLoading: true,
                detail: null,
            };
        case 'GROUPS:GET_GROUP_DETAILS_FAILURE':
            return {
                ...state,
                isLoading: false,
                detail: null,
            };
        case 'GROUPS:GET_GROUP_DETAILS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                detail: action.data,
            };
        case 'GROUPS:GET_GROUP_EVENT_DETAILS':
            return {
                ...state,
                isLoading: true,
                event: null,
            };
        case 'GROUPS:GET_GROUP_EVENT_DETAILS_FAILURE':
            return {
                ...state,
                isLoading: false,
                event: null,
            };
        case 'GROUPS:GET_GROUP_EVENT_DETAILS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                event: action.data,
            };
        case 'GROUPS:ADD_TO_ANDROID_WAITLIST':
            return {
                ...state,
                submitting: true,
                submitted: null,
            };
        case 'GROUPS:ADDED_TO_ANDROID_WAITLIST':
            return {
                ...state,
                submitting: false,
                submitted: action.email,
            };
        case 'GROUPS:RESET_ANDROID_WAITLIST':
            return {
                ...state,
                submitting: false,
                submitted: null,
            };
        default:
            return state;
    }
}

export default app;
